export default __webpack_public_path__ + "static/media/analyticContentIcon.8a27302e.svg";